import { PropsWithChildren } from 'react'

import styled, { css } from 'styled-components'

export const SectionContent = styled.div`
  margin: 10px 0;
`

export const SectionHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  padding: 10px 10px 5px 10px;
`

export const SectionTitle = styled.span`
  font-size: 24px;

  ${({ theme }) => css`
    font-family: ${theme.fonts.title};
    font-weight: ${theme.fonts.titleWeight};
    color: ${theme.colors.text};
  `}
`

type TSectionActionProps = {
  isEnabled?: boolean
}

export const SectionAction = styled.span<
  PropsWithChildren<TSectionActionProps>
>`
  ${({ theme, isEnabled = true }) => css`
    color: ${isEnabled ? theme.colors.textLink : theme.colors.textDisabled};
    font-size: 18px;
  `}
`
